import { gql } from 'graphql.macro';

const GET_STORY_RELATED = gql`
  query storyRelated($hash: String!, $title: String!, $language: String!) {
    storyRelated(hash: $hash, title: $title, language: $language) {
      hash
      createdNews {
        id
        hash
        info {
          slug
          title
          snippet
        }
        source {
          name
        }
      }
      images {
        hash
        name
        hex_dominant_color
        hex_background_color
        hex_title_color
        hex_body_color
        created_at
      }
    }
  }
`;

export default GET_STORY_RELATED;
